import React, { useState, useEffect } from "react";
import classes from "./Movies.module.css";
import Movie from "./Movie";
import axios from 'axios';

// const MOVIE_DATA = [
//   {
//     id: 'm1',
//     name: "Aynen Aynen",
//     nameTR: "3. Sezon 3. Bölüm",
//     image: "aynenaynen.jpg",
//     link: "aynen-aynen-3-sezon-3-bolum",
//     info: `“Aynen Aynen” eğlenceli kadın-erkek ilişkisini konu alan yeni nesil bir mini dizidir. Başrollerinde Kerem Bürsin ve Nilperi Şahinkaya'nın yer aldığı bu dizide, hayal kırıklıklarıyla dolu bir ilişkiden çıkan Nil yeni ev arkadaşı Deniz’le eğlence ve aşk dolu maceralara atılıyor! Nil ve Deniz’in birbirlerini tanımaya başladığı bu süreçte hem karşı tarafa kendilerini göstermek istedikleri hallerini hem de aslında kendi gerçek düşüncelerini görüp bu zıtlık karşısında çok eğleniyoruz! Onları izledikçe adeta kendimizi bulabileceğimiz bir dizi!`,
//     dublaj: false,
//     altyazi: false,
//     trailer: "https://www.youtube.com/watch?v=PTAk6LcQxWU",
//     src: "https://vidoza.net/embed-anmrkpgth9gq.html",
//     embed: true
//   },
//   {
//     id: 'm2',
//     name:
//       "Birds of Prey: And the Fantabulous Emancipation of One Harley Quinn",
//     nameTR: "Yırtıcı Kuşlar (Ve Muhteşem Harley Quinn)",
//     image: "birds.jpg",
//     link: "birds-of-prey",
//     info: `After splitting with the Joker, Harley Quinn joins superheroes Black Canary, Huntress and Renee Montoya to save a young girl from an evil crime lord.`,
//     dublaj: true,
//     altyazi: true,
//     trailer: "https://www.youtube.com/watch?v=kGM4uYZzfu0",
//     src: "https://www.youtube.com/watch?v=kGM4uYZzfu0",
//     embed: false
//   }
// ];


const Movies = props => {
  // const movies = MOVIE_DATA.slice(0, 18).map(movie => {
  //   return (
  //     <Movie
  //       key={movie.id}
  //       id={movie.id}
  //       name={movie.name}
  //       nameTR={movie.nameTR}
  //       image={movie.image}
  //       link={movie.link}
  //       info={movie.info}
  //       dublaj={movie.dublaj}
  //       altyazi={movie.altyazi}
  //       trailer={movie.trailer}
  //       src={movie.src}
  //     />
  //   );
  // });

  const [movieData, setMovieData] = useState([]);

  useEffect(() => {
    axios.get('https://api.themoviedb.org/3/movie/popular?api_key=d527b80849d55bcff1111f0777f4e175&language=tr-TR&page=1')
      .then(res => {
        setMovieData(res.data.results);
      });
  }, []);


  const movies = movieData.slice(0, 18).map(movie => {
    return (
      <Movie
        key={movie.id}
        id={movie.id}
        name={movie.original_title}
        nameTR={movie.title}
        image={movie.poster_path}
        link={movie.link}
        info={movie.overview}
        date={movie.release_date}
        // popularity={movie.popularity}
        // dublaj={movie.dublaj}
        // altyazi={movie.altyazi}
        // trailer={movie.trailer}
        // src={movie.src}
      />
    );
  });

  return <div className={classes.Movies}>{movies}</div>;
};

export default Movies;
